export function emailValidator(value: string) {
  if (!value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
    return true;
  }

  return 'Неверный формат электронной почты';
}
